var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"concept-box",class:{selected: _vm.selected},on:{"click":function($event){return _vm.$emit('click',$event)}}},[_c('div',{staticClass:"text",class:{selected: _vm.selected}},[_vm._v(_vm._s(_vm.concept.label || _vm.concept.name))]),(_vm.selected)?_c('div',{staticClass:"cross-icon"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }